import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=0818bbd6&scoped=true"
import script from "./seckill.vue?vue&type=script&lang=js"
export * from "./seckill.vue?vue&type=script&lang=js"
import style0 from "./seckill.vue?vue&type=style&index=0&id=0818bbd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818bbd6",
  null
  
)

export default component.exports